/**
 * 和我信JSSDK支持方法
 * 
 */
var window = require("./window.js");

if (window.woxin) {
	module.exports = window.woxin;
	
} else {
	module.exports = {
			getCellPhone : function() {return undefined;}
			, getAccessToken : function() {return undefined;}
			, share : function() {return undefined;}
			, loadPayPlugin : function() {return undefined;}
			, getUserStar : function() {return undefined;}
			, getCityCode : function() {return undefined;}
			, getCellPhone : function() {return undefined;} 
			, getLocationX : function() {return undefined;}
			, getLocationY : function() {return undefined;}
			, getAppInfo : function() {return undefined;}
			, getMutiphonedirectory : function(num) {return undefined;}
			, callAliPay : function(sessionString) {return undefined;}
			, selectSystemContact :	function() {return undefined;}
			, wxSetTitle : function(title) {return undefined;}
			, wxChatWithFriend : function () {return undefined}
        	, smsetrightbutton : function () {return undefined;}

	};
	
}



//////////////////
// WEBPACK FOOTER
// ./src/main/javascript/support/woxin.js
// module id = 10
// module chunks = 0